'use strict';

module.exports = {
  getDealType(dealType) {
    switch (dealType) {
      case "GETAWAYS_BOOKING":
      case "GETAWAYS_MARKET_RATE":
      case "GETAWAYS_TONIGHT":
      case "GETAWAYS_VOUCHER":
      case "TRAVEL":
        return "TRAVEL";
      case "GOODS_SHIPPING":
      case "GOODS_VOUCHER":
      case "SHOPPING":
      case "GOODS_MARKETPLACE":
        return "GOODS";
      case "LIVE":
        return "LIVE";
      case "LOCAL":
      case "BEAUTY_NOW":
        return "LOCAL";
      case "CLO":
        return "GPLUS";
      default:
        return "NOTFOUND";
    }
  }
}